var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntroFifthIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 71,
    viewBox: "0 0 75 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5072 34.1781L37.5782 23.9433V8.78418L9.0957 29.5032L23.5072 34.1781Z",
    stroke: "#0D7EBF",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6493 34.1778L46.2705 50.7212L55.1897 62.9983L66.0834 29.5029L51.6493 34.1778Z",
    stroke: "#0D7EBF",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5781 23.9433L51.6491 34.1781L66.0833 29.5032L37.5781 8.78418V23.9433Z",
    stroke: "#0D7EBF",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2703 50.7217H28.8857L19.9666 62.9987H55.1895L46.2703 50.7217Z",
    stroke: "#0D7EBF",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5072 34.1778L9.0957 29.5029L19.9667 62.9983L28.8859 50.7212L23.5072 34.1778Z",
    stroke: "#0D7EBF",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5781 23.9434L23.5071 34.1781L37.5781 38.7621V23.9434Z",
    stroke: "#0D7EBF",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5071 34.1777L28.8858 50.7212L37.5781 38.7618L23.5071 34.1777Z",
    stroke: "#0D7EBF",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5781 23.9434V38.7621L51.6491 34.1781L37.5781 23.9434Z",
    stroke: "#0D7EBF",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8857 50.7212H46.2703L37.578 38.7617L28.8857 50.7212Z",
    stroke: "#0D7EBF",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2704 50.7212L51.6491 34.1777L37.5781 38.7618L46.2704 50.7212Z",
    stroke: "#0D7EBF",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8023 1H35.3767V5.4252H39.8023V1Z",
    stroke: "#0D7EBF",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36757 24.9662L1 29.1748L5.20899 30.5423L6.57656 26.3337L2.36757 24.9662Z",
    stroke: "#0D7EBF",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6039 67.9966L17.1843 70.5977L19.7856 67.0176L16.2052 64.4165L13.6039 67.9966Z",
    stroke: "#0D7EBF",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9658 70.5933L61.5461 67.9922L58.9448 64.4121L55.3645 67.0132L57.9658 70.5933Z",
    stroke: "#0D7EBF",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1696 29.1891L72.802 24.9805L68.593 26.3479L69.9606 30.5566L74.1696 29.1891Z",
    stroke: "#0D7EBF",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroFifthIcon01);
export default __webpack_public_path__ + "static/media/intro_fifth_icon_01.501b675a9874e41053625af1cf653b5f.svg";
export { ForwardRef as ReactComponent };